import React from 'react';
import { Navigate } from 'react-router-dom';

import { useCurrentUser } from 'hooks/use-current-user.hook';

export const DefaultRedirect: React.FC = (): JSX.Element => {
  const [user, loading] = useCurrentUser();

  if (user || loading) {
    return <Navigate to="/hello" />;
  }

  return <Navigate to="/error" />;
};
